// The first view is the default and is left out of the URL.
export const AR_REPORT_VIEWS = ['customers', 'orders'] as const;

export type ArReportView = (typeof AR_REPORT_VIEWS)[number];

// Defaults are left out of the URL: no as-of date means today, no view means customers, no size means 50 rows.
export type ArReportSearch = {
  asOfDate?: string;
  brandIds?: string[];
  stateIds?: string[];
  termsIds?: string[];
  pastDueOnly?: boolean;
  includeCredits?: boolean;
  includeUnapplied?: false;
  q?: string;
  view?: Exclude<ArReportView, 'customers'>;
  sort?: string;
  size?: number;
};

export type ArSearchPatch = { [Key in keyof ArReportSearch]?: ArReportSearch[Key] | undefined };
